import React from 'react'
import useChangeChannelName from './hooks/useChangeChannelName'
import { Icon } from '@tencent/spaui'
import PopChannelNameForm from 'pureComponents/PopChannelNameForm'

const ChangeChannelName = props => {
    const { isShowDialog, onEditClick, onHideDialog } = props

    const {
        content,
        showEdit,
        theChannelName,
        status,
        helpBlock,
        handleFormDataChange,
        handleMouseOver,
        handleMouseLeave,
        handleSubmit,
    } = useChangeChannelName(props)

    return (
        <div>
            <div onMouseOver={() => handleMouseOver()} onMouseLeave={() => handleMouseLeave()}>
                {theChannelName}
                <Icon
                    name="edit"
                    size="large"
                    style={{
                        display: showEdit ? 'inline' : 'none',
                        cursor: 'pointer',
                        position: 'relative',
                        left: '7px',
                        top: '4px',
                    }}
                    onClick={() => onEditClick()}
                />
                <div
                    style={{
                        position: 'absolute',
                        zIndex: '9999',
                        left: '50px',
                        display: isShowDialog ? 'block' : 'none',
                    }}
                >
                    <PopChannelNameForm
                        value={content}
                        _style={{ background: 'white', width: '550px', height: '130px' }}
                        inputStyle={{ margin: '10px' }}
                        buttonStyle={{ position: 'relative', left: '410px', bottom: '20px' }}
                        onChange={val => handleFormDataChange(val)}
                        onCancel={() => onHideDialog()}
                        onSubmit={() => handleSubmit()}
                        status={status}
                        helpBlock={helpBlock}
                    />
                </div>
            </div>
        </div>
    )
}

export default ChangeChannelName
